import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

type SalesAndRevenueDefinitionsTypes = {
  isOffer?: boolean;
};

const SalesAndRevenueDefinitions = ({
  isOffer,
}: SalesAndRevenueDefinitionsTypes) => {
  const { t } = useTranslation();

  const salesAndRevenueDefinitions = [
    !isOffer && apiDefinitions.allOrdersNetSales,
    isOffer
      ? apiDefinitions.ordersNetSales
      : apiDefinitions.loyaltyOrdersNetSales,
    isOffer
      ? apiDefinitions.discountAmount
      : apiDefinitions.loyaltyDiscountAmount,
    apiDefinitions.loyaltyContributionPercentOfSales,
    isOffer ? apiDefinitions.averageCheck : apiDefinitions.loyaltyAverageCheck,
    isOffer && apiDefinitions.averageDiscountPercent,
  ].filter(Boolean);

  return (
    <APIDefinitions
      definitions={salesAndRevenueDefinitions}
      type={t(
        'page.loyaltyPerformanceReport.apiDefinitionTitles.salesAndRevenue.label',
      )}
    />
  );
};

export default SalesAndRevenueDefinitions;
